import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  padding: 50px 0 0;
  color: #4a4a4a;

  @media (max-width: 767.98px) {
    padding-bottom: 2rem;
  }
`;

export const ListingIconsWrapper = styled.div`
  display: none;

  @media (min-width: 48rem) {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
  }
`;

export const ListView = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  border: none;
  background-color: transparent;
  margin: 0 0.5rem;
  cursor: pointer;

  svg {
    filter: invert(69%) sepia(0%) saturate(106%) hue-rotate(169deg) brightness(90%) contrast(84%);
    height: 3rem;
    width: fit-content;
  }

  &:hover {
    svg {
      filter: invert(29%) sepia(52%) saturate(2970%) hue-rotate(187deg) brightness(91%)
        contrast(101%);
    }
  }
`;

export const GridView = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  border: none;
  background-color: transparent;
  margin: 0 0.5rem;
  cursor: pointer;

  svg {
    filter: invert(69%) sepia(0%) saturate(106%) hue-rotate(169deg) brightness(90%) contrast(84%);
    height: 3rem;
    width: fit-content;
  }

  &:hover {
    svg {
      filter: invert(29%) sepia(52%) saturate(2970%) hue-rotate(187deg) brightness(91%)
        contrast(101%);
    }
  }
`;

export const TitleContainer = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  padding: 50px 0px;

  @media (max-width: 767px) {
    padding: 0px;
  }
`;

export const Title = styled.h2`
  color: #4a4a4a;

  @media (max-width: 767.98px) {
    margin-bottom: 0.5rem;
    font-size: 30px;
  }
`;

export const Subtitle = styled.span`
  font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '1rem')};
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular  ')};
  text-transform: capitalize;
  width: fit-content;
  text-align: center;
  margin-bottom: 1.5rem;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};

  @media (max-width: 767.98) {
    margin: 0 0 30px;
  }
`;

export const NavigateWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  position: absolute;
  align-items: center;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1100px) {
    max-width: 1100px;
  }

  @media (min-width: 1280px) {
    max-width: 1220px;
  }
  @media (max-width: 767.98px) {
    justify-content: center;
    position: relative;
    padding-top: 15px;
  }
`;

export const NavigateBtn = styled.button`
  outline: none;
  border: none;
  background-color: transparent;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  cursor: pointer;
  color: #000;

  .arrow {
    max-width: 1rem;
  }

  &[dir='rtl'] {
    .arrow {
      transform: rotate(-180deg);
    }
  }

  @media (max-width: 767.98px) {
    padding-right: 1.3rem;
    padding-left: 1.3rem;
  }

  .arrow {
    height: 1rem;
    width: fit-content;
  }

  &:hover {
    color: #0072c6;
    text-decoration: underline;

    .arrow {
      color: #4a4a4a;
      text-decoration: none;
    }
  }
`;

export const NavigateLabel = styled.span`
  text-transform: uppercase;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '0.75rem')};
  padding: 0 1rem;
`;

export const ArrowIcon = styled.div`
  ${({ rotate }) => rotate && 'transform: rotate(180deg) translateY(10%);'}
`;

export const Spacing = styled.div`
  width: 100%;
  height: 2rem;
`;
